import React, { useEffect, useState } from 'react';
import axios from 'axios';
import OurLayouts from '../layout';

const AdminProfile = () => {
  const rolee = localStorage.getItem("role");
  

  const API_BASE = process.env.REACT_APP_API_URL || 'https://smartclinic-stage.curebay.in/smartclinic/';
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  

  useEffect(() => {
    const fetchAdminProfile = async () => {
      try {
        const token = localStorage.getItem('auth_token');
        const tenantId = localStorage.getItem('tenantId');
        const userId = localStorage.getItem('userId'); // Get userId from localStorage
        const baseUrl = API_BASE.replace(/\/$/, '/');
        
        // Determine API URL based on the logged-in user
        let url;
        if (userId) {
          url = `${baseUrl}auth/clinic-user-details/${tenantId}?userId=${userId}`;
        } else {
          url = `${baseUrl}auth/clinic-user-details/${tenantId}?role=${rolee}`;
        }
        
        const res = await axios.get(url, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        const data = res?.data?.data || res?.data || {};
        // Some backends might wrap in an array; support both
        const obj = Array.isArray(data) ? (data[0] || {}) : data;
        setProfile(obj);
      } catch (e) {
        setError('Failed to load profile');
        console.error(e);
      } finally {
        setLoading(false);
      }
    };
    fetchAdminProfile();
  }, [API_BASE, rolee]); // Added rolee to dependency array

  if (loading) {
    return <div className="p-6">Loading...</div>;
  }
  if (error) {
    return <div className="p-6 text-red-600">{error}</div>;
  }

  const firstName = profile?.firstName || '';
  const lastName = profile?.lastName || '';
  const initials = `${(firstName[0] || '').toUpperCase()}${(lastName[0] || '').toUpperCase()}` || (profile?.userId?.[0] || '').toUpperCase();
  const email = profile?.email || '-';
  const mobile = profile?.mobile || '-';
  const userId = profile?.userId || '-';
  const tenantId = profile?.tenantId || '-';
  const role = profile?.role || '-';
  const statusLabel = profile?.active ? 'Active' : 'Inactive';

  

  return (
    <OurLayouts>
      <div className="max-w-full rounded-lg mx-auto my-5 p-5 font-sans h-screen bg-[#f1f8f7]">
        <div className="mb-8 pb-4 border-b border-gray-200 flex items-center">
          <div className="w-16 h-16 rounded-full bg-gradient-to-b from-[#004172] to-[#3cba84] text-white flex items-center justify-center text-2xl font-semibold mr-4">
            {initials}
          </div>
          <div>
            <h1 className="m-0 text-gray-800 text-2xl font-semibold">{firstName} {lastName}</h1>
            <p className="mt-1 text-gray-500 text-sm">User ID: {userId}</p>
          </div>
        </div>

        <div className=" bg-[#f1f8f7] p-6 rounded-lg shadow-md">
          <h2 className="mt-0 text-[#004276] border-b border-gray-200 pb-3 text-xl font-semibold">User Information</h2>

          <div className="flex gap-5 mb-4">
            <div className="flex-1 min-w-0">
              <label className="block mb-1 font-semibold text-[#004276] text-sm">First Name</label>
              <input type="text" value={firstName} readOnly className="w-full p-2 border border-gray-300 rounded text-sm bg-gray-100" />
            </div>
            <div className="flex-1 min-w-0">
              <label className="block mb-1 font-semibold text-[#004276] text-sm">Last Name</label>
              <input type="text" value={lastName} readOnly className="w-full p-2 border border-gray-300 rounded text-sm bg-gray-100" />
            </div>
          </div>

          <div className="flex gap-5 mb-4">
            <div className="flex-1 min-w-0">
              <label className="block mb-1 font-semibold text-[#004276] text-sm">Email</label>
              <input type="email" value={email} readOnly className="w-full p-2 border border-gray-300 rounded text-sm bg-gray-100" />
            </div>
            <div className="flex-1 min-w-0">
              <label className="block mb-1 font-semibold text-[#004276] text-sm">Mobile</label>
              <input type="tel" value={mobile} readOnly className="w-full p-2 border border-gray-300 rounded text-sm bg-gray-100" />
            </div>
          </div>

          {/* <div className="flex gap-5 mb-4">
           
            <div className="flex-1 min-w-0">
              <label className="block mb-1 font-semibold text-[#004276] text-sm">Role</label>
              <input type="text" value={role} readOnly className="w-full p-2 border border-gray-300 rounded text-sm bg-gray-100" />
            </div>
          </div> */}

          <div className="flex gap-5 mb-1">
           
            <div className="flex-1 min-w-0" />
          </div>
        </div>
      </div>
    </OurLayouts>
  );
};

export default AdminProfile;